import { render, staticRenderFns } from "./CreditAssignmentFileForm.vue?vue&type=template&id=1057658e&"
import script from "./CreditAssignmentFileForm.vue?vue&type=script&lang=js&"
export * from "./CreditAssignmentFileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports